module.exports = __webpack_public_path__ + "img/hk_lv1_product_global@3x.b8910f1b.png";